import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon
} from "react-share";
import { ReactComponent as BookmarkSVG } from "../images/svg/bookmark.svg";
import { ReactComponent as LikeSVG } from "../images/svg/like.svg";
import { ReactComponent as DeleteSVG } from "../images/svg/delete.svg";
import { ReactComponent as EditSVG } from "../images/svg/edit.svg";
import { ReactComponent as CloseSVG } from "../images/svg/close.svg";
import { ReactComponent as LinkSVG } from "../images/svg/links.svg";
import TimeDiff from "../helpers/TimeDiff";
import CountSetter from "../helpers/CountSetter";
import ArticleEditor from "../editors/ArticleEditor";
import CommentEditor from "../editors/CommentEditor";
import store from "../store";

class MainPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      post: {},
      postTitle: "",
      postUsername: "",
      postUserID: "",
      category: "",
      comments: [],
      commentID: 0,
      comment_userID: 0,
      subComments: [],
      renderCount: 0,
      commentSetter: "insert",
      subCommentID: 0,
      subCommentSetter: "insert",
      requestSent: false,
      counter: 2,
      hasFetchedAllPost: false,
      scrollTo: 0,
      isDeleted: false,

      userID: 0,
      username: "",
      bookmarkCount: 0,
      postCount: 0,
      followerCount: 0,
      followingCount: 0,
      profileImage: ""
    };

    this.toggleArticleEditor = this.toggleArticleEditor.bind(this);
    this.toggleCommentEditor = this.toggleCommentEditor.bind(this);
    this.toggleSubCommentEditor = this.toggleSubCommentEditor.bind(this);
    this.setSubCommentID = this.setSubCommentID.bind(this);
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.beforeListFetch = this.beforeListFetch.bind(this);
    this.fetchCommentList = this.fetchCommentList.bind(this);
    //this.registerView = this.registerView.bind(this);
    this.setVoteColor = this.setVoteColor.bind(this);
    this.updatePostDOM = this.updatePostDOM.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleOnScroll);

    fetch(`${this.props.apiROOT}post/${this.props.match.params.title}`)
      .then(res => res.json())
      .then(data => {
        if (data === false) {
          window.history.back();
          return;
        }
        this.setState({
          post: data.post,
          postUsername: data.post.username,
          postUserID: data.post.user_id,
          postTitle: data.post_title,
          category: data.category,
          comments: data.comments,
          subComments: data.sub_comments,
          userID: data.user_id,
          username: data.username,
          profileImage: data.profile_image,
          bookmarkCount: data.bookmark_count,
          postCount: data.post_count,
          followerCount: data.follower_count,
          followingCount: data.following_count
        });
      });

    //this.registerView();
  }

  updatePostDOM(post) {
    this.setState({
      post: post,
      postTitle: post.post_title,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
  }

  // registerView() {
  //   let urlAry = this.props.match.params.title.split("-");
  //   let postID = urlAry[urlAry.length - 1];
  //   fetch(`${this.props.apiROOT}post/registerView/${postID}`)
  //     .then(res => res.text())
  //     .then(data => console.log(data));
  // }

  handleOnScroll() {
    const elemWrapper = document.querySelector(".post-page-column");
    let scrollTop = window.pageYOffset;
    let scrollHeight = elemWrapper.scrollHeight;
    let clientHeight = elemWrapper.clientHeight;

    this.setState({ scrollTo: scrollTop });

    let scrollPosition =
      Math.ceil(scrollTop + clientHeight - 200) >= scrollHeight;

    if (scrollPosition) {
      this.beforeListFetch();
    }
  }

  beforeListFetch() {
    if (this.state.requestSent) return;

    setTimeout(this.fetchCommentList, 2000);
    this.setState({ requestSent: true });
  }

  fetchCommentList() {
    if (this.state.hasFetchedAllPost) return;
    fetch(
      `${this.props.apiROOT}comment/fetchComments/${this.state.post.post_id}/${this.state.counter}`
    )
      .then(res => res.json())
      .then(data => {
        this.setState({
          comments: this.state.comments.concat(data.comments)
        });

        if (data.comments.length < 2) {
          this.setState({
            requestSent: false,
            hasFetchedAllPost: true
          });
        } else {
          this.setState({
            requestSent: false,
            counter: this.state.counter + 2
          });
        }
      });
  }

  toggleArticleEditor() {
    let alertElem = document.querySelector("#alert");
    let editor = document.getElementById("article_editor_frame");
    editor.contentWindow.document.designMode = "On";

    let elem = document.querySelector(".article-editor-wrapper");
    if (elem.classList.contains("hide")) {
      editor.contentWindow.document.body.innerHTML = this.state.post.main_post;
      elem.classList.remove("hide");
      elem.classList.add("visible");
    } else {
      elem.classList.add("hide");
      elem.classList.remove("visible");
      this.props.cleanEditor(alertElem, "Article");
    }
  }

  toggleCommentEditor() {
    let alertElem = document.querySelector("#alert2");
    let editor = document.getElementById("comment_editor_frame");
    editor.contentWindow.document.designMode = "On";

    let elem = document.querySelector(".comment-editor-wrapper");
    if (elem.classList.contains("hide")) {
      elem.classList.remove("hide");
      elem.classList.add("visible");
    } else {
      elem.classList.add("hide");
      elem.classList.remove("visible");
      this.props.cleanEditor(alertElem, "Comment");
    }
  }

  setCommentID = comment_id => e => {
    this.setState({ commentID: comment_id, commentSetter: "update" });
    fetch(`${this.props.apiROOT}comment/edit/${comment_id}`)
      .then(res => res.json())
      .then(data => {
        let editor = document.querySelector("#comment_editor_frame");
        editor.contentWindow.document.body.innerHTML = data.comment;
      });
    this.toggleCommentEditor();
  };

  toggleSubCommentEditor(e) {
    let alertElem = document.querySelector("#alert3");
    let comment_id = e.target.getAttribute("data-cid");
    let comment_user_id = e.target.getAttribute("data-user");
    this.setState({ commentID: comment_id, comment_userID: comment_user_id });
    let editor = document.getElementById("sub_comment_editor_frame");
    editor.contentWindow.document.designMode = "On";

    if (e.target.hasAttribute("data-scid")) {
      let sub_comment_id = e.target.getAttribute("data-scid");
      fetch(`${this.props.apiROOT}subComment/edit/${sub_comment_id}`)
        .then(res => res.json())
        .then(data => {
          let editor = document.querySelector("#sub_comment_editor_frame");
          editor.contentWindow.document.body.innerHTML = data.sub_comment;
        });
    }

    let elem = document.querySelector(".sub-comment-editor-wrapper");
    if (elem.classList.contains("hide")) {
      elem.classList.remove("hide");
      elem.classList.add("visible");
    } else {
      elem.classList.add("hide");
      elem.classList.remove("visible");
      this.props.cleanEditor(alertElem, "SubComment");
    }
  }

  setSubCommentID(e) {
    let sub_comment_id = e.target.getAttribute("data-scid");
    this.setState({ subCommentID: sub_comment_id, subCommentSetter: "update" });
    this.toggleSubCommentEditor(e);
  }

  toggleFollow = userID => e => {
    let elem = document.querySelector(".pg-follow-poster-btn");
    fetch(`${this.props.apiROOT}follow/follow/${userID}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === "followed") {
          elem.classList.remove("unfollowed");
          elem.classList.add("followed");

          elem.classList.add("zoomIn");
          elem.classList.add("animated");
        } else {
          elem.classList.remove("followed");
          elem.classList.add("unfollowed");

          elem.classList.remove("zoomIn");
          elem.classList.remove("animated");
        }
        document.querySelector(".c1-user-following-count span").innerHTML =
          data.followerCount;
      });
  };

  toggleBookmark = postID => e => {
    if (e.target.tagName === "svg") {
      let elem = e.target.parentElement;
      if (elem.classList.contains("neutral")) {
        elem.classList.remove("neutral");
        elem.classList.add("upvote");
        e.target.style.fill = 'green';
        elem.classList.add("bounce");
        elem.classList.add("animated");
      } else {
        e.target.style.fill = '#525252';
        elem.classList.add("neutral");
        elem.classList.remove("upvote");
        elem.classList.remove("bounce");
        elem.classList.remove("animated");
      }
    } else {
      return;
    }
    fetch(`${this.props.apiROOT}bookmark/add/${postID}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          store.getState().columnOne.details.bookmark_count =
            data.bookmarkCount;
          if (document.querySelector(".c1-bookmark-count span")) {
            document.querySelector(".c1-bookmark-count span").innerHTML =
              data.bookmarkCount;
          }
        }
      });
  };

  postDelete = postID => e => {
    if (window.confirm("Are you sure you want to delete this post?")) {
      fetch(`${this.props.apiROOT}post/delete/${postID}`)
        .then(res => res.json())
        .then(data => {
          if (data.status === true) {
            store.getState().columnOne.details.post_count = data.post_count;
            window.history.back();
          }
        });
    }
  };

  setVoteColor(parentElem, tagName, action) {
    parentElem =
      tagName === "svg" ? parentElem : parentElem.parentElement.parentElement;
    let isNeutral = parentElem.classList.contains("neutral") ? true : false;
    let isUpvoted = parentElem.classList.contains("upvote") ? true : false;
    let isDownvoted = parentElem.classList.contains("downvote") ? true : false;
    let isBookmarked = parentElem.classList.contains("bookmarked")
      ? true
      : false;

    if (parentElem.tagName === "SPAN" || parentElem.tagName === "P") {
      if (isNeutral && action === "upvote") {
        parentElem.classList.remove("neutral");
        parentElem.classList.add("upvote");
        parentElem.classList.add("slideInUp");
        parentElem.classList.add("animated");
      }

      if (isUpvoted && action === "upvote") {
        parentElem.classList.remove("upvote");
        parentElem.classList.add("neutral");
        parentElem.classList.remove("slideInUp");
        parentElem.classList.remove("animated");
      }

      if (isBookmarked && action === "bookmark") {
        parentElem.classList.remove("bookmarked");
        parentElem.classList.add("neutral");
        parentElem.classList.remove("bounce");
        parentElem.classList.remove("animated");
      }

      if (isNeutral && action === "bookmark") {
        parentElem.classList.add("bookmarked");
        parentElem.classList.remove("neutral");
        parentElem.classList.add("bounce");
        parentElem.classList.add("animated");
      }

      if (isNeutral && action === "downvote") {
        parentElem.classList.remove("neutral");
        parentElem.classList.add("downvote");
        parentElem.classList.add("slideInDown");
        parentElem.classList.add("animated");
      }

      if (isDownvoted && action === "downvote") {
        parentElem.classList.remove("downvote");
        parentElem.classList.add("neutral");
        parentElem.classList.remove("slideInDown");
        parentElem.classList.remove("animated");
      }
    }
    return;
  }

  postPromote = postID => e => {
    let tagName = e.target.tagName;
    let parentElement = e.target.parentElement;
    this.setVoteColor(parentElement, tagName, "upvote");
    fetch(`${this.props.apiROOT}post/promote/${postID}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          document.querySelector(".pg-p-upvote-sum").innerHTML = data.sum;
        } else {
          this.setVoteColor(parentElement, tagName, "upvote");
        }
      });
  };

  commentPromote = (postID, commentID) => e => {
    let tagName = e.target.tagName;
    let parentElement = e.target.parentElement;
    let oppoElem = document.querySelector(".pg-c-downvote-" + commentID);
    this.setVoteColor(parentElement, tagName, "upvote", oppoElem);
    fetch(`${this.props.apiROOT}comment/promote/${postID}/${commentID}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          document.querySelector(".pg-c-upvote-sum-" + commentID).innerHTML =
            data.sum;
        } else {
          this.setVoteColor(parentElement, tagName, "upvote", oppoElem);
        }
      });
  };

  commentDelete = (postID, commentID) => e => {
    if (window.confirm("Are you sure you want to delete this comment?")) {
      fetch(`${this.props.apiROOT}comment/delete/${postID}/${commentID}`)
        .then(res => res.json())
        .then(data => {
          if (data.status === true) {
            //do nothing
          }
        });
    }
  };

  render() {

    return (
      <React.Fragment>
        <div className="post-page-column">
          {/* post */}
          <div className="pg-post">
            <React.Fragment>
              <p
                className="pg-post-title"
                dangerouslySetInnerHTML={{
                  __html: this.state.post.post_title
                }}
              ></p>
              <div className="pg-post-head">
                {this.state.post.profile_image === "" ? (
                  <div
                    className="pg-poster-image img"
                    style={{
                      backgroundImage:
                        "url(" +
                        this.props.root +
                        "public/images/profile_pic/avatar.jpg)"
                    }}
                  >
                    <img
                      className="img-decoy"
                      alt={this.state.username}
                    />
                  </div>
                ) : (
                    <div
                      className="pg-poster-image img"
                      style={{
                        backgroundImage:
                          "url(" +
                          this.props.root +
                          "public/images/profile_pic/" +
                          this.state.post.profile_image +
                          ")"
                      }}
                    >
                      <img
                        className="img-decoy"
                        alt={this.state.username}
                      />
                    </div>
                  )}

                <div className="pg-poster-profile">
                  <Link
                    to={`/user/${this.state.postUsername.replace(
                      / /g,
                      "-"
                    )}-${this.state.postUserID}`}
                  >
                    <p className="pg-poster-username">
                      {this.state.postUsername}
                    </p>
                  </Link>
                  <p className="pg-post-time">
                    {this.state.post.updated_at !== "" ?
                      <React.Fragment>
                        <span>Updated</span> {" "}  <TimeDiff date={this.state.post.updated_at} />
                      </React.Fragment> :
                      <TimeDiff date={this.state.post.created_at} />
                    }
                  </p>
                </div>

                <div className="clear-float" />
              </div>
              <div className="pg-post-body">
                <p
                  className="pg-post-in"
                  dangerouslySetInnerHTML={{
                    __html: this.state.post.main_post
                  }}
                />
              </div>
            </React.Fragment>

            <div className="pg-post-ft-2">
              {parseInt(this.state.postUserID) ===
                parseInt(store.getState().columnOne.details.user_id) ||
                parseInt(store.getState().columnOne.details.acl) > 0
                ? (
                  <p 
                    className="pg-p-comment-edit"
                    onClick={this.toggleArticleEditor}
                  >
                    <EditSVG /> <span>Edit</span>
                  </p>
                )
                : ""}

              <div className="pg-p-sm-wrapper">
                <FacebookShareButton
                  url={document.URL}
                  quote={this.state.post.post_title}
                >
                  <FacebookIcon
                    size={25}
                    round={true}
                    logoFillColor="#525252"
                    iconBgStyle={{ fill: "white" }}
                  />
                </FacebookShareButton>
              </div>

              <div className="pg-p-sm-wrapper">
                <TwitterShareButton
                  url={document.URL}
                  title={this.state.post.post_title}
                >
                  <TwitterIcon
                    size={25}
                    round={true}
                    logoFillColor="#525252"
                    iconBgStyle={{ fill: "white" }}
                  />
                </TwitterShareButton>
              </div>

              <div className="pg-p-sm-wrapper" style={{ paddingTop: 10 }}>
                <WhatsappShareButton
                  url={document.URL}
                  title={this.state.post.post_title}
                >
                  <WhatsappIcon
                    size={20}
                    round={true}
                    logoFillColor="#525252"
                    iconBgStyle={{ fill: "white" }}
                  />
                </WhatsappShareButton>
              </div>
            </div>
            <div className="clear-float" />

            <div className="pg-post-ft">
              {parseInt(store.getState().columnOne.details.acl) > 0 &&
                <p
                  className="pg-p-comment-add"
                  onClick={this.toggleCommentEditor}
                >
                  Add comment
                </p>
              }

              <p className={`pg-p-upvote-count `}>
                <span
                  className={`pg-p-upvote ${
                    parseInt(store.getState().columnOne.details.user_id) > 0 &&
                      parseInt(this.state.post.status) > 0
                      ? "upvote"
                      : "neutral"
                    }`}
                  onClick={this.postPromote(this.state.post.post_id)}
                >
                  <LikeSVG />
                </span>

                <span className={`pg-p-upvote-sum ${
                  parseInt(store.getState().columnOne.details.user_id) > 0 &&
                    parseInt(this.state.post.status) > 0
                    ? "upvote"
                    : "neutral"
                  }`}>
                  {this.state.post.post_promotes !== undefined && (
                    <CountSetter count={this.state.post.post_promotes} />
                  )}
                </span>

              </p>

              {parseInt(this.state.postUserID) ===
                parseInt(store.getState().columnOne.details.user_id) ||
                parseInt(store.getState().columnOne.details.acl) > 0 ? (
                  <p
                    className="pg-p-comment-delete"
                    onClick={this.postDelete(this.state.post.post_id)}
                  >
                    <DeleteSVG />
                  </p>
                ) : (
                  ""
                )}

              <p
                id={`bookmark${this.state.post.post_id}`}
                className={`pg-p-bookmark ${
                  parseInt(store.getState().columnOne.details.user_id) > 0 &&
                    parseInt(this.state.post.bookmark_id) > 0
                    ? "bookmarked"
                    : "neutral"
                  }`}
                onClick={this.toggleBookmark(this.state.post.post_id)}
              >
                <BookmarkSVG />
              </p>
            </div>
          </div>

          {/* comment */}
          {this.state.comments.map(c => (
            <div
              className="pg-comment"
              id={`pg-comment-${c.comment_id}`}
              key={c.comment_id}
            >
              <div className="pg-comment-head">
                <div className="pg-commenter-profile">
                  <Link
                    to={`/user/${c.username.replace(/ /g, "-")}-${c.user_id}`}
                  >
                    <p className="pg-commenter-username">{c.username}</p>
                  </Link>
                  <p className="pg-comment-time">
                    <TimeDiff date={c.created_at} />
                  </p>
                </div>
                <div className="clear-float" />
              </div>
              <div className="pg-comment-body">
                <p
                  className={`pg-comment-in pg-comment-in-${c.comment_id}`}
                  dangerouslySetInnerHTML={{
                    __html: c.comment
                  }}
                />
              </div>

              <div className="pg-comment-ft">
                <p className="pg-c-upvote-count">
                  <span
                    className={`pg-c-upvote-${c.comment_id} ${
                      parseInt(store.getState().columnOne.details.user_id) >
                        0 && c.status > 0
                        ? "upvote"
                        : "neutral"
                      } pg-c-upvote`}
                    onClick={this.commentPromote(
                      this.state.post.post_id,
                      c.comment_id
                    )}
                  >
                    <LikeSVG />
                  </span>

                  <span className={`pg-c-upvote-sum-${c.comment_id} ${
                    parseInt(store.getState().columnOne.details.user_id) >
                      0 && c.status > 0
                      ? "upvote"
                      : "neutral"
                    }`}>
                    <CountSetter count={c.comment_promotes} />
                  </span>

                </p>

                {parseInt(c.user_id) ===
                  parseInt(store.getState().columnOne.details.user_id) ||
                  parseInt(store.getState().columnOne.details.acl) > 0 ? (
                    <p
                      className="pg-c-comment-edit"
                      onClick={this.setCommentID(c.comment_id)}
                    >
                      <EditSVG /> <span>Edit</span>
                    </p>
                  ) : (
                    ""
                  )}

                {parseInt(c.user_id) ===
                  parseInt(store.getState().columnOne.details.user_id) ||
                  parseInt(store.getState().columnOne.details.acl) > 0 ? (
                    <p className="pg-c-comment-delete" style={{ marginTop: 8 }}>
                      <span
                        onClick={this.commentDelete(
                          this.state.post.post_id,
                          c.comment_id
                        )}
                      >
                        <DeleteSVG />
                      </span>
                    </p>
                  ) : (
                    ""
                  )}

              </div>
            </div>
          ))}
        </div>

        <div className="article-editor-wrapper hide">
          <span
            className="article-editor-wrapper-close"
            onClick={this.toggleArticleEditor}
          >
            <CloseSVG /> Close
          </span>

          <ArticleEditor
            apiROOT={this.props.apiROOT}
            root={this.props.root}
            category={this.state.category}
            post_title={this.state.postTitle}
            post_id={this.state.post.post_id}
            cleanEditor={this.props.cleanEditor}
            updatePostDOM={this.updatePostDOM}
            setter="update"
          />
        </div>

        <div className="comment-editor-wrapper hide">
          <span
            className="comment-editor-wrapper-close"
            onClick={this.toggleCommentEditor}
          >
            <CloseSVG /> Close
          </span>

          <CommentEditor
            apiROOT={this.props.apiROOT}
            root={this.props.root}
            post_id={this.state.post.post_id}
            comment_id={this.state.commentID}
            post_title={this.state.post.post_title}
            user_id={this.state.post.user_id}
            setter={this.state.commentSetter}
            cleanEditor={this.props.cleanEditor}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default MainPost;
